import { h } from 'preact';
import { RichText } from 'prismic-reactjs';
import { linkResolver } from '../../prismic';

export default function Text(props) {
	return (
		<RichText render={props.primary.text} linkResolver={linkResolver} />
	);
}
